export default "__VITE_ASSET__CjZxwVh1__"